import React from 'react';

const WEBFORM_URL = 'https://menu-and-catalog-maker-webform.vercel.app/';

const ManagedServiceBanner = ({ email }) => {
    const handleOpen = () => {
        window.open(
            `${WEBFORM_URL}?email=${encodeURIComponent(email)}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <div className="msb-container">
            <p className="msb-title">Let us handle your catalog</p>
            <p className="msb-subtitle">Our team builds and manages your menu or catalog for you.</p>
            <button className="msb-btn" onClick={handleOpen}>
                Request the Menu &amp; Catalog Maker AI team to manage my business
            </button>
        </div>
    );
};

export default ManagedServiceBanner;
